import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from "react-router-dom";
import { Card, ActionButton, GhostButton, Icon, colors } from "../components/ui/index.js";
export function NotFoundPage() {
    const navigate = useNavigate();
    return (_jsx("div", { style: {
            display: "grid",
            placeItems: "center",
            padding: "48px 16px",
        }, children: _jsxs(Card, { style: {
                maxWidth: 460,
                width: "100%",
                textAlign: "center",
                padding: 32,
            }, children: [_jsx("div", { style: {
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 64,
                        height: 64,
                        borderRadius: 999,
                        background: colors.surfaceSecondary,
                        color: colors.textTertiary,
                        marginBottom: 16,
                    }, children: _jsx(Icon, { name: "map-pin", size: 28 }) }), _jsx("h1", { style: {
                        margin: "0 0 8px 0",
                        fontSize: "1.4rem",
                        fontWeight: 700,
                        color: colors.text,
                        letterSpacing: "-0.01em",
                    }, children: "That page doesn't exist" }), _jsx("p", { style: {
                        margin: "0 0 20px 0",
                        color: colors.textSecondary,
                        fontSize: "0.9rem",
                        lineHeight: 1.5,
                    }, children: "The link you followed may be broken, or the page may have moved. The dashboard is a good place to start over." }), _jsxs("div", { style: {
                        display: "flex",
                        gap: 8,
                        justifyContent: "center",
                        flexWrap: "wrap",
                    }, children: [_jsxs(ActionButton, { onClick: () => navigate("/"), children: [_jsx(Icon, { name: "home", size: 12 }), " Back to dashboard"] }), _jsxs(GhostButton, { onClick: () => navigate(-1), children: [_jsx(Icon, { name: "chevron-left", size: 12 }), " Go back"] })] })] }) }));
}
